import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Breadcrumb from "../../common/header/Breadcrumb";
import Header from "../../common/header/Header";
import PaymentSignatureTemplate from "../../components/NotificationSettings/PaymentSignatureTemplate";

const PaymentSignature = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
      <Box sx={{ flexGrow: 1 }} className="page-background">
        <Header />
        <Breadcrumb />
        <PaymentSignatureTemplate/>
      </Box>
    </>
  )
}

export default PaymentSignature